import axios from "@/libs/axios";
import {handleCatch} from "@/utils";
export default {
    async getCertificateBlankStatus() {
        try {
            const response = await axios.get(`certificates/certificate_blank_status`)
            const {data} = response
            return data.data
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
}
